import HorizontalTable from './HorizontalTable';
export default HorizontalTable;
